// @flow

import React, { PureComponent } from 'react';
import ProjectVersionSteps from '../../../virtual-component-releases/step-component/ProjectVersionSteps';
import { DialogInner } from '../../components/Popup';

export default class ProjectVersionSelectView extends PureComponent<*, *> {
    render() {
        const { field, storedValue, ...props } = this.props;

        return (
            <DialogInner minWidth={220}>
                <ProjectVersionSteps isOpen={field?.config.isOpen} {...props} />
            </DialogInner>
        );
    }
}
